var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Token-Transfers',{attrs:{"transfers":_vm.transfers,"headers":_vm.headers,"loading":_vm.loading,"sortBy":_vm.currentOptions.sortBy[0],"count":_vm.transferCount,"withTransactionData":true,"withTokenData":true,"address":_vm.address},on:{"pagination":_vm.onPagination,"update:options":_vm.getTransfers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }